import api from 'utils/api';
import { request } from './api';
import * as Alert from './alert';

/**
 * Action constants
 */
export const BUILDOPTIMIZE_REQUEST = 'BUILDOPTIMIZE_REQUEST';
export const BUILDOPTIMIZE_SEARCH_SUCCESS = 'BUILDOPTIMIZE_SEARCH_SUCCESS';
export const BUILDOPTIMIZE_ADD_SUCCESS = 'BUILDOPTIMIZE_ADD_SUCCESS';
export const BUILDOPTIMIZE_UPDATE = 'BUILDOPTIMIZE_UPDATE';
export const BUILDOPTIMIZE_REMOVE_SECURITY = 'BUILDOPTIMIZE_REMOVE_SECURITY';
export const BUILDOPTIMIZE_REMOVE_ALL = 'BUILDOPTIMIZE_REMOVE_ALL';
export const BUILDOPTIMIZE_LOAD_PORTFOLIO = 'BUILDOPTIMIZE_LOAD_PORTFOLIO';
export const BUILDOPTIMIZE_CLEAR = 'BUILDOPTIMIZE_CLEAR';

/**
 * Action creators
 */
export function fetchId(id) {
  return (dispatch) => {
    dispatch({ type: BUILDOPTIMIZE_REQUEST });

    return dispatch(request('get', `/portfolio/${id}/`)).then(
      (portfolio) => {
        const weights = portfolio.weights.split(',');
        const symbols = portfolio.symbols.split(',');

        const parsed = symbols.reduce((acc, val, idx) => {
          acc[val] = Math.round(Number(weights[idx]) * 10000) / 100;

          return acc;
        }, {});
        const max = symbols.length > 20 ? `&max=${symbols.length}` : '';

        return api
          .request('get', `/security/`, {
            query: `?symbols=${symbols}${max}`,
          })
          .then(
            (data) => {
              const parseData = data.reduce((acc, val) => {
                acc[val.ticker] = {
                  ...val,
                  weight: parsed[val.ticker],
                };

                return acc;
              }, {});

              return dispatch({
                type: BUILDOPTIMIZE_LOAD_PORTFOLIO,
                portfolio: parseData,
              });
            },
            (error) => {
              dispatch({ type: BUILDOPTIMIZE_ADD_SUCCESS, security: null });

              return dispatch(
                Alert.show({ type: 'error', msg: parseErr(error) })
              );
            }
          );
      },
      (error) => {
        dispatch({ type: BUILDOPTIMIZE_ADD_SUCCESS, security: null });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function add(id) {
  return (dispatch) => {
    dispatch({ type: BUILDOPTIMIZE_REQUEST });

    return dispatch(request('get', `/security/${id}/`)).then(
      (data) => {
        return dispatch({ type: BUILDOPTIMIZE_ADD_SUCCESS, security: data });
      },
      (error) => {
        dispatch({ type: BUILDOPTIMIZE_ADD_SUCCESS, security: null });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function update(field, value) {
  return {
    type: BUILDOPTIMIZE_UPDATE,
    field,
    value,
  };
}

export function search(id) {
  return (dispatch) => {
    dispatch({ type: BUILDOPTIMIZE_REQUEST });

    return dispatch(request('get', `/security/search?term=${id}`)).then(
      (data) => dispatch({ type: BUILDOPTIMIZE_SEARCH_SUCCESS, data }),
      (error) => {
        dispatch({ type: BUILDOPTIMIZE_SEARCH_SUCCESS, data: [] });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}
// export function search(id, region = 'CA') {
//   return (dispatch) => {
//     dispatch({ type: BUILDML_REQUEST });

//     return dispatch(
//       request('get', `/security/search?term=${id}&region=${region}`)
//     ).then(
//       (data) => dispatch({ type: BUILDML_SEARCH_SUCCESS, data }),
//       (error) => {
//         dispatch({ type: BUILDML_SEARCH_SUCCESS, data: [] });

//         return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
//       }
//     );
//   };
// }

export function remove(ticker) {
  return {
    type: BUILDOPTIMIZE_REMOVE_SECURITY,
    ticker,
  };
}

export function removeAll() {
  return {
    type: BUILDOPTIMIZE_REMOVE_ALL,
  };
}

// Clears all local BUILDOPTIMIZE data when leaving client view
export function clearBuildOptimize() {
  return { type: BUILDOPTIMIZE_CLEAR };
}

/**
 * Helper Functions
 */
function parseErr(err) {
  if (err.non_field_errors) {
    return err.non_field_errors[0];
  }
  return err.msg || err.detail || 'Server Offline';
}
